import React, { useEffect, useState } from 'react';
import FontW7 from "../../Font/FontW7"
import FontW9 from "../../Font/FontW9"
import { Button, Grid, withStyles } from "@material-ui/core"
import { isAndroid, isMobileOnly, osName } from 'react-device-detect'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Player from '@vimeo/player'

const style = theme => ({
    root: {
        minHeight: '100vh',
        backgroundColor: '#000000 !important',
        alignItems: 'center',
        display: 'flex',
        position: 'relative',
    },
    fixScroll: {
        position: 'absolute',
        top: 0,
        [theme.breakpoints.down('xs')]: {
            top: 30
        }
    },
    fixContainer: {
        // position: 'relative',
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: 1100,
        },
        height: '100%',
        alignContent: 'space-around',
        margin: '0 auto',
    },
    fixTitle: {
        zIndex: 1,
        marginBottom: 0,
        paddingTop: 50,
        ['@media (min-width:960px)']: {
            paddingBottom: 20,
        },
        ['@media (min-width:1200px)']: {
            paddingBottom: 50,
        },
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 20,
        },
    },
    fix32: {
        fontSize: 28,
    },
    fix48: {
        fontSize: 40,
    },
    boxContent: {
        zIndex: 1,
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
            flexBasis: '100%',
            flexGrow: '0',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: '50%',
            flexBasis: '50%',
            flexGrow: '0',
        },
    },
    content: {
        fontSize: 18,
        lineHeight: '28px',
        marginLeft: 50,
        ['@media (min-width:960px)']: {
            marginBottom: 20,
        },
        ['@media (min-width:1200px)']: {
            marginBottom: 80,
        },
        textAlign: 'justify',
        [theme.breakpoints.down('sm')]: {
            marginBottom: 20,
        },
        [theme.breakpoints.down('xs')]: {
            margin: '0 10px',
        },
    },
    boxVideo: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        [theme.breakpoints.down('md')]: {
            position: isMobileOnly ? 'relative' : 'absolute',
        },
    },
    boxInfomation: {
        zIndex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
            flexBasis: '100%',
            flexGrow: '0',
            justifyContent: 'center',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: '50%',
            flexBasis: '50%',
            flexGrow: '0',
            justifyContent: 'flex-end',
        },
    },
    sublink: {
        textAlign: 'center',
        position: 'unset',
        ['@media (min-width:1200px)']: {
            paddingRight: 50,
        },
        paddingBottom: 80,
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 80,
            paddingRight: 0,
        },
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 50,
        },
    },
    fixSubW9: {
        fontSize: 59,
        marginTop: 0,
        marginLeft: -68,
        marginRight: -68,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginRight: 0,
        },
        [theme.breakpoints.down('xs')]: {
            textIndent: -25,
            wordSpacing: -5,
            fontSize: 45,
        },
    },
    fontContact: {
        fontSize: 24,
        color: 'white',
        marginTop: -75,
        marginLeft: 100,
        [theme.breakpoints.down('xs')]: {
            marginTop: -65,
            fontSize: 18,
            marginLeft: 75,
        },
        '&& span': {
            fontSize: 12,
            [theme.breakpoints.down('xs')]: {
                fontSize: 10,
            },
        },
    },
    imgContact: {
        width: 420,
        [theme.breakpoints.down('xs')]: {
            width: 310,
        },
    },
    bgVideo: {
        [theme.breakpoints.up('sm')]: {
            paddingBottom: 30,
        },
    },
})

function Slider(props) {
    const { classes, content } = props
    const { fullScreen } = props;
    const [open, setOpen] = React.useState(false);
    const [mess, setMess] = useState('')

    function handleClickOpen() {
        setOpen(true);
        setMess('---src: ' + document.getElementById('bgVideo').src +
            ' ---osName: ' + osName +
            ' ---isAndroid: ' + isAndroid
            // ' ---video Android: ' + document.getElementById('videoAndroid').toString()
        )
    }

    function handleClose() {
        setOpen(false);
    }

    // const [isMuted, setIsMuted] = useState(true)
    // const [loadSRC, setLoadSRC] = useState(true)
    // useEffect(() => {
    //    const iframeVideo = document.getElementById('bgVideo')
    //    if (isAndroid && isMuted === true) {
    //       let source = 'https://player.vimeo.com/video/317173798?autoplay=1&loop=1&autopause=0&background=0&muted=0&controls=1'
    //       // iframeVideo.attr('src', source);
    //       iframeVideo.src = source
    //       iframeVideo.src = iframeVideo.src
    //       // iframeVideo.contentWindow.location.reload(true)
    //       setIsMuted(false)
    //    } else if(loadSRC) {
    //       let source = 'https://player.vimeo.com/video/317173798?autoplay=1&loop=1&autopause=0&background=1&muted=1&controls=0'
    //       // iframeVideo.attr('src', source);
    //       iframeVideo.src = source
    //       iframeVideo.src = iframeVideo.src
    //       // iframeVideo.contentWindow.location.reload(true)
    //       setLoadSRC(false)
    //    }
    // })
    useEffect(() => {
        if (isAndroid) {
            var iframe = document.querySelector('iframe');
            var player = new Player(iframe);
            player.ready().then(async () => {
                await player.setCurrentTime(0)
                player.play()
            })
        }
    }, [])
    return (
        <Grid
            id="section-2"
            className={classes.root}
        >
            <span className={classes.fixScroll} data-scroll-index="1"/>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">{"Use Google's location service?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {mess}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Disagree
                    </Button>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid
                container
                className={classes.fixContainer}
            >
                <Grid
                    item xs={12}
                    className={"wow fadeInUp " + classes.fixTitle}
                    data-wow-delay=".6s"
                >
                    <h3
                        data-position="centerCenter"
                        // data-vertical="-100"
                        data-horizontal="0"
                        data-show-transition="up"
                        data-show-duration="1000"
                        data-show-delay="500"
                        data-width="100%"
                        data-hide-transition="down"
                        style={{
                            textAlign: 'center',
                            paddingBottom: 10,
                            marginTop: 0,
                            marginBottom: 0,
                        }}
                    >
                        <FontW7 className={classes.fix32}>Inner Resource Development</FontW7>
                    </h3>
                    <h2
                        data-position="centerCenter"
                        // data-vertical="0"
                        data-horizontal="0"
                        data-show-transition="up"
                        data-show-duration="1000"
                        data-show-delay="500"
                        data-width="100%"
                        data-hide-transition="down"
                        style={{
                            textAlign: 'center',
                            marginTop: 0,
                            marginBottom: 0,
                        }}
                    >
                        <FontW9 className={classes.fix48}>
                            「内なる未開の地」<br/>
                            を開拓する旅路。
                        </FontW9>
                    </h2>
                </Grid>
                <Grid
                    item xs={12} className={classes.boxVideo}>
                    {isAndroid ?
                        <iframe
                            id={'bgVideo'}
                            src={'https://player.vimeo.com/video/12345?autoplay=1&autopause=1&loop=1&muted=1&background=1'}
                            width="100%"
                            allow="autoplay"
                            height="100%"
                            frameBorder="0"
                            // allowFullScreen
                            className={classes.bgVideo}
                        />
                        :
                        <iframe
                            id={'bgVideo'}
                            src={'https://player.vimeo.com/video/12345?autoplay=1&loop=1&autopause=0&background=1&muted=1&controls=0'}
                            width="100%"
                            allow="autoplay"
                            height="100%"
                            frameBorder="0"
                            allowFullScreen
                            className={classes.bgVideo}
                        />
                    }
                </Grid>
                <Grid
                    item
                    md={6}
                    xs={12}
                    className={
                        "wow fadeInLeft "
                        + classes.boxContent
                    }
                    data-wow-delay=".4s"
                >
                    <p
                        className={
                            "sp-layer subtitle "
                            + classes.content
                        }
                        data-position="centerCenter"
                        data-vertical="50"
                        data-horizontal="0"
                        data-show-transition="up"
                        data-show-duration="1000"
                        data-show-delay="700"
                        data-width="80%"
                        data-hide-transition="down"
                        style={{ position: 'unset' }}
                    >
                        <FontW7>
                            {content}
                        </FontW7>
                    </p>
                </Grid>
                <Grid
                    item
                    md={6}
                    xs={12}
                    className={
                        "wow fadeInRight "
                        + classes.boxInfomation
                    }
                    data-wow-delay=".6s"
                >
                    <div
                        className={
                            "sp-layer sublink "
                            + classes.sublink
                        }
                        // data-position="bottomRight"
                        data-vertical="200"
                        data-horizontal="0"
                        data-show-transition="up"
                        data-show-duration="1000"
                        data-show-delay="900"
                        data-hide-transition="down"
                    >
                        <h3
                            style={{ fontSize: 26, marginBottom: 0, marginTop: 0 }}
                        >
                            <FontW7>無料オンライン講座（全１７回）</FontW7>
                        </h3>
                        <h2
                            className={classes.fixSubW9}
                        >
                            <FontW9>「Who am I?」</FontW9>
                        </h2>
                        <a
                            href="https://line.me/R/ti/p/%40bdi5394s"
                            target="_blank" rel="noopener noreferrer"
                        >
                            <img src='img/lineButton.png' alt='' className={classes.imgContact}/>
                            <p
                                className={classes.fontContact}
                            >
                                に登録して、無料受講する。<br/>
                                <span>※いつでも簡単に停止できます。(通知オフ機能)</span>
                            </p>
                        </a>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={handleClickOpen} color="primary" autoFocus>
                        url iframe
                    </Button>
                </Grid>
            </Grid>

        </Grid>
    )
}

export default withMobileDialog()(withStyles(style)(Slider))
